module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row row-fix rntrc-box"
  }, [_c('div', {
    staticClass: "block-plate"
  }, [_c('span', [_vm._v(_vm._s(_vm.vehicle.plate))])]), _vm._v(" "), _c('div', {
    staticClass: "block-vehicle"
  }, [_c('b', {
    staticClass: "upper"
  }, [_vm._v(_vm._s(_vm.vehicle.model.brand.name))]), _vm._v(" "), _c('div', {
    staticClass: "vehicle-model"
  }, [_c('b', [_vm._v(_vm._s(_vm._f("firstWord")(_vm.vehicle.model.name)))])]), _vm._v("\n          " + _vm._s(_vm._f("fromSecWord")(_vm.vehicle.model.name)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-rntrc-vinculate"
  }, [_c('form', [_c('div', {
    class: {
      'has-error': _vm.errors.has('serialNumber')
    }
  }, [_c('b', [_vm._v("TAG Número")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.serialNumber),
      expression: "serialNumber"
    }],
    staticClass: "form-control input-tag-number",
    attrs: {
      "type": "text",
      "name": "serialNumber",
      "placeholder": "0000000000"
    },
    domProps: {
      "value": (_vm.serialNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.serialNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('serialNumber')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-fleet"
  }, [_c('b', [_vm._v("Frota Própria?")]), _vm._v(" "), _c('div', {
    staticClass: "fleet-switch"
  }, [_c('div', {
    staticClass: "onoffswitch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownFleet),
      expression: "ownFleet"
    }],
    staticClass: "onoffswitch-checkbox",
    attrs: {
      "type": "checkbox",
      "id": 'rntrc-switch' + _vm.vehicle.vehicleId
    },
    domProps: {
      "checked": Array.isArray(_vm.ownFleet) ? _vm._i(_vm.ownFleet, null) > -1 : (_vm.ownFleet)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ownFleet,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ownFleet = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.ownFleet = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ownFleet = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "onoffswitch-label",
    attrs: {
      "for": 'rntrc-switch' + _vm.vehicle.vehicleId
    }
  }, [_c('span', {
    staticClass: "onoffswitch-inner"
  }), _vm._v(" "), _c('span', {
    staticClass: "onoffswitch-switch"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-button-vinculate"
  }, [(_vm.isVinculated) ? _c('button', {
    staticClass: "btn btn-activate-tag",
    attrs: {
      "name": "button"
    }
  }, [_vm._v("\n          Vinculado\n        ")]) : _c('button', {
    staticClass: "btn btn-activate",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.vinculate()
      }
    }
  }, [_vm._v("\n          Vincular\n        ")])]), _vm._v(" "), (_vm.errorMsg) ? _c('div', {
    staticClass: "col-xs-12 no-padding margin-b20"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n          " + _vm._s(_vm.errorMsg) + "\n        ")])]) : _vm._e()]), _vm._v(" "), (!_vm.ownFleet) ? _c('div', {
    staticClass: "third-party-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "thirdPartyName"
    }
  }, [_vm._v("Nome:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.driverName),
      expression: "driver.driverName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "Proprietário do veículo"
    },
    domProps: {
      "value": (_vm.driver.driverName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.driver, "driverName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('taxpayerIdNumber')
    }
  }, [_c('label', {
    attrs: {
      "for": "thirdPartyCpfCnpj"
    }
  }, [_vm._v("CPF ou CNPJ:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.driver.taxpayerIdNumber),
      expression: "driver.taxpayerIdNumber",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:18|cpfCnpj'),
      expression: "'required|max:18|cpfCnpj'"
    }, {
      name: "mask-cpf-cnpj",
      rawName: "v-mask-cpf-cnpj"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
      "name": "taxpayerIdNumber",
      "placeholder": "CPF/CNPJ do proprietário",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.driver.taxpayerIdNumber)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.driver, "taxpayerIdNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('taxpayerIdNumber')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('rntrc')
    }
  }, [_c('label', {
    attrs: {
      "for": "thirdPartyRntrc"
    }
  }, [_vm._v("Nº do RNTRC:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal|max:12'),
      expression: "'required|decimal|max:12'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicle.rntrc),
      expression: "vehicle.rntrc"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "rntrc",
      "placeholder": "Número de registro",
      "maxlength": "12"
    },
    domProps: {
      "value": (_vm.vehicle.rntrc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicle, "rntrc", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('rntrc')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "thirdPartyEmail"
    }
  }, [_vm._v("E-mail:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver.driverEmail),
      expression: "driver.driverEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": "E-mail do proprietário"
    },
    domProps: {
      "value": (_vm.driver.driverEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.driver, "driverEmail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "bold"
  }, [_vm._v("Dados do Proprietário")]), _vm._v(" "), _c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-f2781332!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/rntrc/vehicle-rntrc.vue
// module id = 2224
// module chunks = 1